import { Link } from 'react-router-dom'
import { ROUTES } from '@/lib/paths'
import { cn } from '@/lib/cn'
import { Icon, Section, Surface } from '@/components/ui'
import styles from './WorkTogetherCta.module.css'

interface WorkTogetherCtaProps {
  /**
   * `band` wraps the panel in its own full-width section (every page except
   * home). `inline` renders the bare panel so the home page can place it
   * beside the testimonial carousel.
   */
  layout?: 'band' | 'inline'
  className?: string
}

/** The closing "Let's Work Together" panel. The whole panel is one link. */
export const WorkTogetherCta = ({
  layout = 'band',
  className,
}: WorkTogetherCtaProps) => {
  const panel = (
    <Surface
      as={Link}
      to={ROUTES.contact}
      pad={20}
      radius="card"
      interactive
      className={cn(styles.panel, layout === 'band' && styles.band, className)}
    >
      <h2 className="t-22">Let&rsquo;s Work Together</h2>
      <span className={styles.link}>
        Lets talk
        <Icon name="arrowUpRight" size={12} className={styles.arrow} />
      </span>
    </Surface>
  )

  if (layout === 'inline') return panel
  return <Section as="aside">{panel}</Section>
}
